import z from 'zod';

import type { QcsResourceSlice } from '../core/resourceSliceUtils';
import { PersonalPurposeTypeEnum } from '../mileage-tracker-purpose/mileageTrackerPurposeTypes';

export const MILEAGE_TRACKER_RATES_REDUCER_KEY = 'mileageTrackerRatesStore';
export type MILEAGE_TRACKER_RATES_REDUCER_KEY = typeof MILEAGE_TRACKER_RATES_REDUCER_KEY;

const CustomRateSchema = z.object({
  id: z.string(),
  createdAt: z.string(),
  modifiedAt: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  rate: z.number(),
  purposeType: PersonalPurposeTypeEnum,
  isDeleted: z.boolean(),
});

export const RateSchema = z.object({
  id: z.string().optional(),
  clientId: z.string().optional(),
  createdAt: z.string().optional(),
  modifiedAt: z.string().optional(),
  year: z.string(),
  rate: z.number(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  customRates: z.array(CustomRateSchema).optional(),
});

export type MileageTrackerRatesType = z.infer<typeof RateSchema>;
export type MileageTrackerRatesState = QcsResourceSlice<MileageTrackerRatesType>;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [MILEAGE_TRACKER_RATES_REDUCER_KEY]: MileageTrackerRatesState;
  }
}
